(() => {
  const gallery = document.querySelector('[data-casekoo-linkoo-gallery]');
  if (!gallery || gallery.dataset.casekooLazyReady === 'true') return;
  if (gallery.hasAttribute('data-ck-gallery-loading')) return;

  gallery.dataset.casekooLazyReady = 'true';
  const section = gallery.closest('.shopify-section') || gallery.parentElement;
  const lazySelector = 'img[data-casekoo-gallery-lazy]';
  const thumbnailLazySelector = `.product-thumbnail-list-item ${lazySelector}`;

  const hydrate = (image) => {
    if (!(image instanceof HTMLImageElement) || !image.matches(lazySelector)) return;

    const srcset = image.dataset.srcset;
    const src = image.dataset.src;
    image.loading = 'eager';
    image.fetchPriority = 'low';
    if (srcset) image.srcset = srcset;
    if (src) image.src = src;
    image.removeAttribute('data-srcset');
    image.removeAttribute('data-src');
    image.removeAttribute('data-casekoo-gallery-lazy');
  };

  const hydrateWithin = (element) => {
    if (!(element instanceof Element)) return;
    if (element.matches(lazySelector)) hydrate(element);
    element.querySelectorAll(lazySelector).forEach(hydrate);
  };

  const hydrateSlideAndNeighbors = (slide) => {
    if (!(slide instanceof Element)) return;
    hydrateWithin(slide.previousElementSibling);
    hydrateWithin(slide);
    hydrateWithin(slide.nextElementSibling);

    const mediaId = slide.dataset.mediaId;
    if (!mediaId || !section) return;
    section.querySelectorAll(`.product-thumbnail-list-item[data-media-id="${CSS.escape(mediaId)}"]`).forEach(hydrateWithin);
  };

  const getCurrentSlide = () => {
    const slides = [...gallery.querySelectorAll('.feature-media-item')];
    if (window.matchMedia('(max-width: 989px)').matches) {
      return gallery.querySelector('.feature-media-item.is-active, .feature-media-item[aria-hidden="false"]') || slides[0];
    }

    return slides.find((slide) => getComputedStyle(slide).display !== 'none')
      || gallery.querySelector('.feature-media-item[aria-hidden="false"], .feature-media-item.is-active')
      || slides[0];
  };

  const hydrateCurrentSlide = () => {
    window.requestAnimationFrame(() => hydrateSlideAndNeighbors(getCurrentSlide()));
  };

  // Let Alpine/Splide finish hiding non-active slides before observing them.
  // Otherwise their brief pre-initialized layout can make several hidden images
  // look visible and start downloading during the first paint.
  window.setTimeout(() => {
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          hydrate(entry.target);
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '350px 0px', threshold: 0.01 }
    );
    section?.querySelectorAll(thumbnailLazySelector).forEach((image) => observer.observe(image));
  } else {
    section?.querySelectorAll('.product-thumbnail-list-item--active').forEach(hydrateWithin);
  }

  section?.addEventListener(
    'pointerdown',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const thumbnail = target.closest('.product-thumbnail-list-item');
      if (thumbnail) {
        hydrateWithin(thumbnail);
        const mediaId = thumbnail.dataset.mediaId;
        if (mediaId) {
          const slide = gallery.querySelector(`.feature-media-item[data-media-id="${CSS.escape(mediaId)}"]`);
          hydrateSlideAndNeighbors(slide);
        }
        return;
      }

      if (gallery.contains(target) && target.closest('button')) {
        hydrateSlideAndNeighbors(getCurrentSlide());
      }
    },
    { capture: true, passive: true }
  );

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      const target = mutation.target;
      if (!(target instanceof Element)) return;

      if (target.matches('.product-thumbnail-list-item--active')) hydrateWithin(target);
    });
  });

  if (section) {
    mutationObserver.observe(section, {
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style', 'aria-hidden'],
    });

    section.addEventListener('shapes:product:mediachange', (event) => {
      const mediaId = event.detail?.mediaId;
      const slide = mediaId == null
        ? null
        : gallery.querySelector(`.feature-media-item[data-media-id="${CSS.escape(String(mediaId))}"]`);
      if (slide) hydrateSlideAndNeighbors(slide);
      hydrateCurrentSlide();
    }, true);
    section.addEventListener('shapes:product:variantchange', hydrateCurrentSlide, true);
    section.addEventListener('theme:variant:change', hydrateCurrentSlide, true);
    section.addEventListener('mediaVisible', (event) => {
      hydrateSlideAndNeighbors(event.target.closest?.('.feature-media-item'));
    }, true);
  }
  hydrateCurrentSlide();
  }, 350);
})();
